import { useState, useEffect } from 'react';
import { fetchConfig } from '../config';

/**
 * Hook to load runtime configuration from backend
 * Handles loading state and errors
 */
export function useConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('useConfig: Fetching config...');
    fetchConfig()
      .then(cfg => {
        console.log('useConfig: Config loaded:', cfg);
        setConfig(cfg);
        setLoading(false);
      })
      .catch(err => {
        console.error('useConfig: Error loading config:', err);
        setError(err);
        setLoading(false);
      });
  }, []);

  return { config, loading, error };
}
